import { useState } from 'react';

import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { WorkOrderField } from '@atom/types/work';
import { DETAIL_FIELD_WIDTH } from '@atom/utilities/taskUtilities';

interface Props {
  field: WorkOrderField;
  onChange: (fieldId: string, value: any) => void;
  onBlur: (fieldId: string, value: any) => void;
  isDisabled: boolean;
}

const WorkOrderTextField = ({ field, onChange, onBlur, isDisabled }: Props) => {
  const [value, setValue] = useState<string>(field?.value || '');

  const handleChange = event => {
    setValue(event.target.value);
    onChange(field.id, event.target.value);
  };

  const handleOnBlur = event => {
    if (field?.value !== event.target.value) {
      setValue(event.target.value);
      onBlur(field.id, event.target.value);
    }
  };

  const style = {
    width: DETAIL_FIELD_WIDTH,
  };

  return (
    <div>
      <TextOverflowTooltip
        width={DETAIL_FIELD_WIDTH}
        text={field.title}
        color={colors.neutral.dim}
        fontSize={fonts.sm}
      />
      <TextField
        id={field.id}
        value={value}
        style={style}
        onChange={handleChange}
        onBlur={handleOnBlur}
        disabled={isDisabled}
        multiline
      />
    </div>
  );
};

export default WorkOrderTextField;
